import siteConfig from '@/config.json'
import { basename, legacyImageUrl } from '@/helpers/images'

export const useCommon = () => {
  const getImageUrl = (imageUrl, defaultLocalFile = siteConfig.org.logoFilename) =>
    legacyImageUrl(imageUrl, siteConfig, defaultLocalFile)

  const getImageUrlBase = (imageUrl, defaultLocalFile = siteConfig.org.logoFilename) => {
    let url = `/sites/${siteConfig.key}/${defaultLocalFile}`
    if (imageUrl) {
      const imageName = basename(imageUrl)
      const system = imageUrl.includes('system/') ? 'system/' : ''
      url = `${siteConfig.legacyImagesBaseUrl}/${system}${imageName}`
    }
    return url
  }

  return {
    getImageUrl,
    getImageUrlBase,
  }
}
